// extracted by mini-css-extract-plugin
module.exports = {"wrap":"groupsettings_wrap__2y3pO","dangerGroup":"groupsettings_dangerGroup__1MwJ7"};